import { render, staticRenderFns } from "./PICDettaglio.vue?vue&type=template&id=51a0b470&scoped=true"
import script from "./PICDettaglio.vue?vue&type=script&lang=js"
export * from "./PICDettaglio.vue?vue&type=script&lang=js"
import style0 from "./PICDettaglio.vue?vue&type=style&index=0&id=51a0b470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a0b470",
  null
  
)

export default component.exports